import { render } from "./DistributorShopItemCard.vue?vue&type=template&id=bae9ed70&scoped=true&ts=true"
import script from "./DistributorShopItemCard.vue?vue&type=script&lang=ts"
export * from "./DistributorShopItemCard.vue?vue&type=script&lang=ts"

import "./DistributorShopItemCard.vue?vue&type=style&index=0&id=bae9ed70&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bae9ed70"]])

export default __exports__